
export default class SettingService {

    private static pmpsiteurl: string;
    private static fcall: string;
    private static dcall: string;
    private static createdDate: Date;
    private static clientID: Date;
    private static tenantID: string;
    private static theme: string;
    private static Dateformat: string;
    private static clmMailboxid: string;
    private static browserDefaultLanguageSelected: string;
    private static userLanguage: string;
    private static DisplayBusiness: string;
    private static Homepagethemedisplay: string;
    private static ExpiringSoon: string;
    private static RequestColumns:any;
    private static ContractColumns:any;
    private static TaskColumns:any;
    private static RequestDashboard:any;
    private static ContractDashboard:any;
    private static DashboardSampleData:any;
    private static Language:any;
    private static ShowNavBarTeams:any;
    private static AIApiUrl:any;
    private static AzureAI:any;
    public static Init(
        pmpsiteurl: string,
        fcall: string,
        dcall: string,
        createdDate: Date,
        clientID: Date,
        tenantID: string,
        theme:string,
        Dateformat:string,
        clmMailboxid:string,
        userLanguage:string,
        browserDefaultLanguageSelected:string,
        DisplayBusiness:string,
        Homepagethemedisplay:string,
        ExpiringSoon:string,
        RequestColumns:any,
        ContractColumns:any,
        TaskColumns:any,
        RequestDashboard:any,
        ContractDashboard:any,
        DashboardSampleData:any,
        Language:any,
        ShowNavBarTeams:any,
        AIApiUrl:any,
        AzureAI:any,
    ) {
        this.pmpsiteurl = pmpsiteurl;
        this.fcall = fcall;
        this.dcall = dcall;
        this.createdDate = createdDate;
        this.clientID = clientID;
        this.tenantID = tenantID;
        this.theme=theme;
        this.Dateformat=Dateformat;
        this.clmMailboxid=clmMailboxid;
        this.userLanguage=userLanguage;
        this.browserDefaultLanguageSelected = browserDefaultLanguageSelected;
        this.DisplayBusiness=DisplayBusiness;
        this.Homepagethemedisplay = Homepagethemedisplay;
        this.ExpiringSoon = ExpiringSoon;
        this.RequestColumns=RequestColumns;
        this.ContractColumns=ContractColumns;
        this.TaskColumns=TaskColumns;
        this.RequestDashboard=RequestDashboard;
        this.ContractDashboard=ContractDashboard;
        this.DashboardSampleData=DashboardSampleData;
        this.Language=Language;
        this.ShowNavBarTeams=ShowNavBarTeams;
        this.AIApiUrl=AIApiUrl;
        this.AzureAI=AzureAI;
    }


    public static GetFirstInstalledDate() {
        return this.createdDate;
    }
    public static GetFirstCall() {
        return this.fcall;
    }


    public static GetPMPURL(): string {
        return this.pmpsiteurl;
    }
    public static GetFCall(): string {
        return this.fcall;
    }
    public static GetDCall(): string {
        return this.dcall;
    }
    public static GetClientID() {
        return this.clientID;
    }
    public static GetTenantID() {
        return this.tenantID;
    }
    public static GetTheme() {
        return "Site";
        // return this.theme;
    }
   
    public static GetDateformat() {
        return "MM/DD/YYYY";
    }
    public static GetclmMailboxid() {
        return this.clmMailboxid;
    }

    public static GetUserLanguage(){
        return this.userLanguage
    }

    public static GetIsBrowserDefaultLangaugeEnabled(){
        return this.browserDefaultLanguageSelected;
    }
    public static GetDisplayBusinessUnit() {
        return this.DisplayBusiness;
    }
    public static GetHomepagethemedisplay() {
        return this.Homepagethemedisplay; 
    }
    public static GetExpiringSoonDays() {
        return this.ExpiringSoon;//30
    }
    public static setExpiringSoonDays(value) {
        return this.ExpiringSoon=value;
    }
    public static SetTheme(value){
        this.theme = value
    }

    public static SetUserLanguage(value){
        this.userLanguage = value
    }

    public static SetBrowserDefaultLanguage(value){
        this.browserDefaultLanguageSelected = value
    }

    public static SetDisplayBusinessUnit(value){
        this.DisplayBusiness = value
    }

    public static SetHomepagethemedisplay(value){
        this.Homepagethemedisplay = value
    }
   
    public static setRequestColumns(value){
        this.RequestColumns=value;
    }
    
    public static setContractColumns(value){
        this.ContractColumns=value;
    }
    public static setTaskColumns(value){
        this.TaskColumns=value;
    }
    public static getRequestColumns(){
        return  this.RequestColumns;
    }

    public static getContractColumns(){
        return  this.ContractColumns;
    }

    public static getTaskColumns(){
        return  this.TaskColumns;
    }

    public static getRequestDashboard(){
        return this.RequestDashboard;
    }

    public static setRequestDashboard(value){
        return this.RequestDashboard=value;
    }

    public static getContractDashboard(){
        return this.ContractDashboard;
    }
    
    public static setContractDashboard(value){
        return this.ContractDashboard=value;
    }

    public static getDashboardSampleData(){
        return this.DashboardSampleData;
    }
    
    public static setDashboardSampleData(value){
        return this.DashboardSampleData=value;
    }
    
    public static getLanguageData(){
        return this.Language;
    }
    
    public static setLanguageData(value){
        return this.Language=value;
    }

    public static getHideNavBar(){
        return this.ShowNavBarTeams||"Yes";
    }
    
    public static setHideNavBar(value){
        return this.ShowNavBarTeams=value;
    }

    public static getAIApiUrl(){
        return this.AIApiUrl;
    }
    
    public static setAIApiUrl(value){
        return this.AIApiUrl=value;
    }

    public static getAzureAI(){
        return this.AzureAI;
    }
    
    public static setAzureAI(value){
        return this.AzureAI=value;
    }
}
